<template>
  <b-card no-body>
    <b-card-body>
      <admin-special-offer-detail
        ref="adminSpecialOfferDetail"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import AdminSpecialOfferDetail from '@/views/pages/special-offer/admin/SpecialOfferDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    AdminSpecialOfferDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },
  created() {
    const { id } = this.$route.params;
    this.id = id;
    this.getWarehouseData(id);
  },
  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .editOffer(this.id, {
          ...data
        })
        .then(response => {
          if (response.status) {
            this.showSuccessMessage(`${response.message}`);
            this.$router.push({ name: 'admin_special_offer' });
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    getWarehouseData(id) {
      this.submitting = true;
      useService
        .getOffer(id)
        .then(response => {
          this.data = response.data;

          const {
            provider,
            status,
            estimatedReturnCost,
            totalCost,
            additionalCost,
            ruleCost,
            serviceFee,
            providerBaseCost
          } = response.data;

          this.data = {
            providerId: provider.id,
            status,
            estimatedReturnCost,
            totalCost,
            additionalCost,
            ruleCost,
            serviceFee,
            providerBaseCost
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
